class LanguageSwitch {
    constructor(elem) {
        this.elem = elem;
        this.controlContainer = this.elem.querySelector('.language-switch__control-container');
        this.boundBodyClickListener = this.bodyClickListener.bind(this);
    }

    init() {
        this.initToggleClickHandler();
    }

    initToggleClickHandler() {
        this.controlContainer.addEventListener('click', () => {
            this.elem.classList.toggle('active');

            if (this.elem.classList.contains('active')) {
                requestAnimationFrame(() => {
                    document.body.addEventListener('click', this.boundBodyClickListener);
                });
            }
        });
    }

    bodyClickListener(e) {
        const { target } = e;

        const clickedInsideControl = this.controlContainer === target || this.controlContainer.contains(target);
        const clickedInsideSwitch = this.elem === target || this.elem.contains(target);

        if (!clickedInsideSwitch || clickedInsideControl) {
            this.elem.classList.remove('active');
            document.body.removeEventListener('click', this.boundBodyClickListener);
        }
    }
}

export default LanguageSwitch;
